<template>
  <div class="v-room-profile">
    <b-card class="v-room-profile__card">
      <div class="row v-room-profile__card__header mb-3">
        <div class="col-6 text-right">
          <h3>مدیریت اتاق</h3>
        </div>
        <div class="col-6"></div>
      </div>

      <hr class="mt-3 mb-3" />

      <b-skeleton-table v-if="loading" :rows="4" :columns="2">
      </b-skeleton-table>

      <div v-else class="row">
        <div class="col-12 col-md-12 v-room-profile__info">
          <b-tooltip
            v-if="room.firstAgentID !== room.agentID"
            :target="'agent-id' + room.id"
            triggers="hover"
          >
            پشتیبان تغییر کرده است
          </b-tooltip>
          <label :for="'agent-id' + room.id"><b>پشتیبان</b></label>
          <div>
            <v-select
              :id="'agent-id' + room.id"
              :disabled="actionLoading"
              :components="{ Deselect }"
              :options="agents"
              :value="room.agent"
              label="name"
              @input="(status) => changeAgent(room.id, status.id)"
            >
              <template #selected-option="{ name }">
                <div style="display: flex; align-items: baseline">
                  <strong>{{ name }}</strong>
                </div>
              </template>
              <template #option="{ name }">
                <div style="display: flex; align-items: baseline">
                  <strong>{{ name }}</strong>
                </div>
              </template>
            </v-select>
          </div>
        </div>
        <div class="col-12 col-md-6 v-room-profile__info">
          <label for=""><b>زمان قرار</b></label>
          <div>
            {{ room.dateTime }}
          </div>
        </div>
        <div class="col-12 col-md-6 v-room-profile__info">
          <label for=""><b>وضعیت</b></label>
          <div>
            <v-select
              :disabled="actionLoading"
              :components="{ Deselect }"
              :options="statusItems"
              :value="room.status"
              label="label"
              @input="(status) => changeStatus(room.id, status.id)"
            >
              <template #selected-option="{ label }">
                <div style="display: flex; align-items: baseline">
                  <strong>{{ label }}</strong>
                </div>
              </template>
              <template #option="{ label }">
                <div style="display: flex; align-items: baseline">
                  <strong>{{ label }}</strong>
                </div>
              </template>
            </v-select>
          </div>
        </div>
        <div class="col-12 col-md-6 v-room-profile__info">
          <label for=""><b>زمان ساخت قرار</b></label>
          <div>
            {{ room.create }}
          </div>
        </div>
        <div class="col-12 col-md-6 v-room-profile__info">
          <label for=""><b>لینک قرار پشتیبان</b></label>
          <div>
            <b-button
              size="sm"
              :href="baseLink + room.agentLink"
              variant="primary"
              class="ml-2"
              target="_blank"
            >
              لینک ورود پشتیبان
            </b-button>
          </div>
        </div>
        <div class="col-12 col-md-6 v-room-profile__info">
          <label for=""><b>لینک قرار کاربر</b></label>
          <div>
            <b-button
              size="sm"
              :href="baseLink + room.userLink"
              variant="primary"
              class="ml-2"
              target="_blank"
            >
              لینک ورود کاربر
            </b-button>
          </div>
        </div>
      </div>

      <div v-if="!loading && this.room.records" class="v-room-profile__records">
        <hr class="mt-3 mb-3" />

        <div class="row">
          <div class="col-6 text-right">
            <h3>فیلم های ضبط شده</h3>
          </div>
        </div>

        <div
          class="mb-3 text-right"
          v-for="(record, index) in this.room.records"
          :key="index"
        >
          <div class="mb-2"><b>تاریخ رکورد : </b>{{ record.start_time }}</div>
          <b-button :href="record.url" variant="primary" class="ml-2">
            دانلود ویدئو
          </b-button>
          <hr class="mt-3 mb-3" />
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import Rooms from "@/httpservices/Rooms";
import Agents from "@/httpservices/Agents";

export default {
  name: "RoomProfile",

  data() {
    return {
      Deselect: {
        render: (createElement) => createElement("span", ""),
      },
      room: {},
      modalShow: false,
      loading: true,
      roomId: "",
      actionLoading: false,

      baseLink: process.env.VUE_APP_INTERVIEW_RESERVE_URL,

      statusItems: [
        { id: "0", label: "باز" },
        { id: "1", label: "تکمیل شده" },
      ],

      agents: [],

      fields: [
        {
          key: "agent",
          label: "پشتیبان",
          sortable: true,
          class: "text-right",
        },
        {
          key: "dateTime",
          label: "زمان",
          sortable: true,
          class: "text-right",
        },
        {
          key: "status",
          label: "وضعیت",
          sortable: true,
          class: "text-right",
        },
        { key: "actions", label: "عملیات" },
      ],
    };
  },

  mounted() {
    this.getRoom();
    this.getAgents();
  },

  methods: {
    changeStatus(roomId, status) {
      this.actionLoading = true;

      Rooms.changeStatus(roomId, status)
        .then(() => {
          this.getRoom();

          this.$swal({
            position: "top-right",
            icon: "success",
            title: "وضعیت با موفقیت تغییر کرد",
            showConfirmButton: false,
            timer: 3000,
            toast: true,
          });
        })
        .catch(() => {})
        .finally(() => {
          this.actionLoading = false;
        });
    },

    changeAgent(roomId, agentId) {
      this.actionLoading = true;

      Rooms.changeAgentId(roomId, agentId)
        .then(() => {
          this.getRoom();
          this.$swal({
            position: "top-right",
            icon: "success",
            title: "پشتیبان با موفقیت تغییر کرد",
            showConfirmButton: false,
            timer: 3000,
            toast: true,
          });
        })
        .catch(() => {})
        .finally(() => {
          this.actionLoading = false;
        });
    },

    getRoom() {
      Rooms.getRoom(this.$route.params.id)
        .then((response) => {
          this.room = response.data.data;
          this.room.agent = {
            id: response.data.data.agentID,
            name: response.data.data.agentName,
          };
          this.room.status =
            response.data.data.status === "0"
              ? { id: "0", label: "باز" }
              : { id: "1", label: "تکمیل شده" };
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },

    getAgents() {
      this.actionLoading = true;
      Agents.getAgents()
        .then((response) => {
          this.agents = [];
          response.data.data.forEach((element) => {
            if (element.status === "1") {
              this.agents.push({
                id: element.id,
                mobile: element.mobile,
                name: element.name,
                status: element.statusّ,
              });
            }
          });
        })
        .catch(() => {})
        .finally(() => {
          this.actionLoading = false;
        });
    },

    deleteRoom(id) {
      Rooms.deleteRoom(id)
        .then(() => {
          this.$swal({
            position: "top-right",
            icon: "success",
            title: "اتاق با موفقیت حذف شد",
            showConfirmButton: false,
            timer: 3000,
            toast: true,
          });
          this.getRoom();
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss">
.v-room-profile {
  padding: 24px;
  font-size: 16px;

  &__info {
    text-align: right;
    margin-bottom: 24px;

    .v-select {
      width: 100%;
    }
  }

  .v-select {
    width: 212px;
  }

  table {
    direction: rtl;
    text-align: right;
  }

  &__add-agent {
    .modal-body {
      padding: 16px;
    }

    text-align: right;

    &__header {
      h1 {
      }
    }
  }

  &__records {
    h3 {
      width: max-content;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      margin-bottom: 14px;
    }
  }
}
</style>
